

let initialState = [];

function inviteds(state = initialState, action) {
    
    if (action.type === "INVITED_ADD") {
        return [].concat(state, [
            { username:action.user.username, email: action.user.email}
        ])
    }
    if (action.type === "INVITED_REMOVE" && action.user.email  ) {
        return state.filter(user => (user.email !== action.user.email) || (user.username !== action.user.username));
    }
    return state;
}


export default inviteds;